import { render, staticRenderFns } from "./BoardAdminList.vue?vue&type=template&id=12ae4a64"
import script from "./BoardAdminList.ts?vue&type=script&lang=ts&external"
export * from "./BoardAdminList.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardAdminList.vue?vue&type=style&index=0&id=12ae4a64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports